import { useState } from "react";
import { MapPinOff, Loader2, RefreshCw } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { capayGeoCheck } from "@/lib/api";

/** Popup shown when an AUS Capay money-out is attempted from outside Australia. */
export function GeoBlockDialog({ geo, onClose, onRetry }) {
  const [busy, setBusy] = useState(false);
  const where = geo?.resolved ? [geo.city, geo.region, geo.country].filter(Boolean).join(", ") : `an unknown location (${geo?.error || "no lookup"})`;
  const retry = async () => {
    setBusy(true);
    try { await onRetry?.(); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent className="max-w-md" data-testid="geo-block-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-rose-700"><MapPinOff className="w-5 h-5" />Location must be in Australia to disburse</DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-2 text-sm text-slate-700 pt-1">
              <p>You're currently showing as <b data-testid="geo-block-where">{where}</b>{geo?.ip ? <span className="text-muted-foreground"> (IP {geo.ip})</span> : null}.</p>
              <p>Corporate Alliance holds payments initiated from outside Australia in their compliance queue. Connect to the Australian VPN, then check again.</p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="ghost" onClick={onClose} data-testid="geo-block-cancel">Cancel</Button>
          <Button onClick={retry} disabled={busy} data-testid="geo-block-retry">{busy ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <RefreshCw className="w-4 h-4 mr-1" />}I'm on the VPN — check again</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

/** Returns {allowed, geo}. Never throws — a lookup failure only blocks when the server says enforced. */
export async function runGeoGate(flow) {
  try {
    const geo = await capayGeoCheck(flow);
    return { allowed: !!geo.allowed, geo };
  } catch (e) {
    return { allowed: true, geo: null, error: e };
  }
}
